<i18n>
{
  "fr": {
    "Title": "Rapport de disponibilité"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title')"/>
    <AppContainer>
      <MemberGenerateForm
        @submit="setMember" />
      <DateGenerateForm
        @submit="setDates"/>
      <div>
        <ButtonGenerate
          @click="generate" />
      </div>
    </AppContainer>
  </section>
</template>

<script>
import MemberGenerateForm from '@/components/reports/MemberGenerateForm';
import DateGenerateForm from '@/components/reports/DateGenerateForm';

export default {
  components: {
    MemberGenerateForm,
    DateGenerateForm,
  },
  data() {
    return {
      form: {
        member: null,
        startDate: null,
        endDate: null,
      },
    };
  },
  methods: {
    setDates(dates) {
      this.form.startDate = dates.startDate;
      this.form.endDate = dates.endDate;
    },
    setMember(member) {
      this.form.member = member.member;
    },
    generate() {
      this.$router.push({ name: 'Availability-Global', query: this.form });
    },
  },
};
</script>
